var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"beystravel spinner-container"},[_c('clip-loader',{attrs:{"loading":true,"size":_vm.small ? '15px' : '35px',"color":_vm.spinnerColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }